
export const Burger = (props : any) => {
    return (
        <svg width={props.width || "32px"} height={props.height || "32px"} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="icon/succed/32" fill={props.color || "#3333CC"}>
                    <path d="M24.5,20.25 C25.1903559,20.25 25.75,20.8096441 25.75,21.5 C25.75,22.1472087 25.2581253,22.6795339 24.6278052,22.7435464 L24.5,22.75 L7.5,22.75 C6.80964406,22.75 6.25,22.1903559 6.25,21.5 C6.25,20.8527913 6.74187466,20.3204661 7.37219476,20.2564536 L7.5,20.25 L24.5,20.25 Z M24.5,9.25 C25.1903559,9.25 25.75,9.80964406 25.75,10.5 C25.75,11.1472087 25.2581253,11.6795339 24.6278052,11.7435464 L24.5,11.75 L7.5,11.75 C6.80964406,11.75 6.25,11.1903559 6.25,10.5 C6.25,9.85279131 6.74187466,9.3204661 7.37219476,9.25645361 L7.5,9.25 L24.5,9.25 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </svg>
    );
}
